(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/member-popover.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/member-popover.js');
'use strict';

const {
  ReactPopover
} = svs.components;
const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
const SPACEBAR_KEY_CODE = 32;
const ENTER_KEY = 13;
const MemberPopover = _ref => {
  let {
    children,
    className
  } = _ref;
  const triggerContentRef = React.useRef([]);
  const closePopOver = () => {
    triggerContentRef.current.click();
  };
  const handleKeydown = e => {
    switch (e.keyCode) {
      case SPACEBAR_KEY_CODE:
      case ENTER_KEY:
        e.stopPropagation();
        e.preventDefault();
        closePopOver();
        break;
      default:
    }
  };
  return React.createElement("div", {
    className: "u-flex"
  }, React.createElement(ReactPopover, {
    arrowBranding: "bg-white",
    branding: "syndicate-member-popover",
    className: "".concat(className, " u-flex"),
    closeOnOutsideClick: true,
    onClick: closePopOver,
    onKeyDown: handleKeydown,
    position: "left",
    triggerContent: React.createElement("div", {
      className: "u-flex",
      ref: triggerContentRef
    }, React.createElement(IconButton, {
      "aria-label": "Hantera medlem",
      className: "padding-v",
      onKeyDown: e => e.stopPropagation(),
      size: 100
    }, React.createElement(Icon, {
      icon: "nav-more-vertical",
      size: 100
    })))
  }, React.createElement("ul", {
    className: "padding-0"
  }, children)));
};
svs.arena.pages.teams.components.MemberPopover = MemberPopover;

 })(window);